import { Target, Flag, CheckCircle2 } from "lucide-react";
import { useSite, imgUrl } from "@/context/SiteContext";

export default function AboutSection({ profile }) {
  const { t } = useSite();
  return (
    <section id="tentang" className="border-b border-slate-200 bg-white py-16 sm:py-24" data-testid="about-section">
      <div className="mx-auto grid max-w-7xl gap-12 px-4 sm:px-6 lg:grid-cols-12 lg:px-8">
        <div className="lg:col-span-5">
          {profile.about_image && <img src={imgUrl(profile.about_image)} alt={profile.company_name} className="h-80 w-full object-cover lg:h-full lg:min-h-[420px]" data-testid="about-image" />}
        </div>
        <div className="lg:col-span-7">
          <p className="eyebrow mb-4">{t("about.eyebrow")}</p>
          <h2 className="text-3xl font-bold tracking-tight text-[#0F2B48] lg:text-4xl">{t("about.title")}</h2>
          <p className="mt-5 leading-relaxed text-slate-600" data-testid="about-text">{profile.about}</p>
          <div className="mt-8 grid gap-6 sm:grid-cols-2">
            <div className="border-l-2 border-[#D97706] pl-4" data-testid="about-vision">
              <p className="flex items-center gap-2 text-sm font-bold text-[#0F2B48]"><Target size={16} className="text-[#D97706]" /> {t("about.vision")}</p>
              <p className="mt-2 text-sm text-slate-600">{profile.vision}</p>
            </div>
            <div className="border-l-2 border-[#0284C7] pl-4" data-testid="about-mission">
              <p className="flex items-center gap-2 text-sm font-bold text-[#0F2B48]"><Flag size={16} className="text-[#0284C7]" /> {t("about.mission")}</p>
              <ul className="mt-2 space-y-1.5 text-sm text-slate-600">{(profile.mission || []).map((m, i) => <li key={i}>• {m}</li>)}</ul>
            </div>
          </div>
          {profile.values?.length > 0 && (
            <>
              <p className="eyebrow mb-4 mt-10">{t("about.values")}</p>
              <div className="grid gap-px border border-slate-200 bg-slate-200 sm:grid-cols-2">
                {profile.values.map((v, i) => (
                  <div key={i} className="bg-[#FAF9F6] p-5" data-testid={`about-value-${i}`}>
                    <p className="flex items-center gap-2 font-semibold text-[#0F2B48]"><CheckCircle2 size={16} className="text-emerald-600" /> {v.title}</p>
                    <p className="mt-1 text-sm text-slate-600">{v.desc}</p>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  );
}
